import axios from "axios"
import { getCookie } from "../utils/getCookies"
import { rutas } from "../rutas/rutas"

export const getTokenCf = async(token, criptomoneda)=>{

    const token2 = getCookie('token')
     return axios({
        url: `${rutas.getPrecioCF}`  ,
        method: 'get',
        headers:{
            token: token2
        },
     
    })

   

}
